document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".iframe-music");
  const playBtn = document.querySelector(".play-btn");

  playBtn.addEventListener("click", function () {
    container.classList.toggle("open");
    playBtn.classList.toggle("active");
  });
});
